// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Helpful?',
  helpful: 'Helpful',
  not_helpful: 'Not helpful',
  thanks: 'Thanks, noted.',
};
